/**
 * Order
 * Order APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionError = 'payment-failed' | 'payment-declined' | 'wallet-not-set';

export const SubscriptionError = {
    PaymentFailed: 'payment-failed' as SubscriptionError,
    PaymentDeclined: 'payment-declined' as SubscriptionError,
    WalletNotSet: 'wallet-not-set' as SubscriptionError
};

